import { userAtom } from '@/global-store';
import clearStorageWithExeptions from '@/helpers/clearStorageWithExeptions';
import { demoUser } from '@/http/constants';
import ContentCard from '@components/ContentCard';
import MainBlogArticles from '@components/MainBlogArticles.jsx';
import ProductCards from '@components/ProductCards';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { IconHome2 } from '@tabler/icons-react';
import { useAtom } from 'jotai';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function checkForGotoParam(path) {
    // if path is set, always navigate to goto if present or to path oherwise
    let goto = new URLSearchParams(window.location.search)?.get('goto');

    if (!goto && path) goto = path;

    if (goto) {
        if (!goto.startsWith('/')) goto = goto = '/' + goto;

        if (window.location.pathname === goto) return console.log('already on the right page');

        console.log('demoPage | redirecting to', window.location.origin + goto);
        return window.location.assign(window.location.origin + goto);
    }
}

export function Component() {
    const [user, setUser] = useAtom(userAtom);
    const { t } = useTranslation();

    const activateDemoMode = useCallback(
        function activateDemoModeCb() {
            console.log('activating demo mode');
            clearStorageWithExeptions();
            localStorage.setItem('selectedDomain', '"audit.zugang4all.de"');
            localStorage.setItem('demoMode', 'true');
            localStorage.setItem('tokenExpires', '4099852799'); // 2099 in unix timestamp
            setUser(demoUser);
            checkForGotoParam('/demo');
        },
        [setUser]
    );

    useEffect(() => {
        if (!user)
            activateDemoMode(); // if not logged in, activate demo mode automatically
        else {
            // checked if logged in as demo user
            if (user.id === 1083) {
                console.log('demo mode is already activated');

                document.body.style.overflow = 'auto';
                document.querySelector('#boot-screen').style.display = 'none';

                // check if goto param is set and redirect to it
                checkForGotoParam();
            } else if (confirm(t('demoAlreadyLoggedIn'))) {
                // if logged in as normal user, ask if demo mode should be activated
                activateDemoMode();
            } else {
                console.log('user dont want to activate demo mode');
                // user dont want to activate demo mode
                return window.location.assign('/');
            }
        }
    }, [user, t, activateDemoMode]);

    return (
        <>
            <Grid size={12}>
                <ContentCard icon={IconHome2} title={t('dashboardDemoModeText')}>
                    <Box
                        sx={{
                            alignItems: 'stretch',
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 4
                        }}
                    >
                        <Box
                            sx={{
                                fontWeight: 500,
                                width: '100%'
                            }}
                        >
                            {t('dashboardDemoText')}
                        </Box>

                        <ProductCards />
                    </Box>
                </ContentCard>
            </Grid>
            <Grid size={12}>
                <MainBlogArticles />
            </Grid>
        </>
    );
}
